import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const Rooms = ({ value }) => {
  const { t } = useTranslation()
  if (!value) return null
  return <Typography>{t('{{n}} rooms', { n: value })}</Typography>
}
